import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import CourierCompanyData from '@/store/entities/back-couriercompany-list'

interface CourierCompanyState extends ListState<any> {
    orderInfo: CourierCompanyData,
}

class CourierCompanyMutations extends ListMutations<any>{

}
class CourierCompany extends ListModule<CourierCompanyState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
    }
    actions = {
        async getCourierCompanyList(context: ActionContext<CourierCompanyState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/CourierCompany/GetCourierCompanyList', { params: payload.data });
            let result = reponse.data.result as Array<CourierCompanyState>;
            return result;
        },
    };
    mutations = {
        setCurrentPage(state: CourierCompanyState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: CourierCompanyState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const couriercompanymodel = new CourierCompany();
export default couriercompanymodel;